module.exports = __webpack_public_path__ + "static/media/level_end.3931d957.mp3";